import { useEffect, useRef, useState } from 'react'

/**
 * Появился ли у блока скролл. CSS такого не умеет, поэтому сравниваем высоты сами
 * и пересчитываем, когда меняется сам блок или его содержимое
 */
export const useScrollable = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const [isScrollable, setIsScrollable] = useState(false)

  useEffect(() => {
    const node = ref.current

    if (!node) return

    const update = () => {
      const { overflowY } = getComputedStyle(node)
      const canScroll = overflowY === 'auto' || overflowY === 'scroll'

      setIsScrollable(canScroll && node.scrollHeight - node.clientHeight > 1)
    }

    update()

    if (typeof ResizeObserver === 'undefined') return

    const observer = new ResizeObserver(update)

    // сам блок меняет высоту вместе с окном, дети — когда раскрывают группы
    observer.observe(node)
    Array.from(node.children).forEach((child) => observer.observe(child))

    return () => observer.disconnect()
  }, [])

  return { ref, isScrollable }
}
